<template>
  <CreateEditResponsibleModal
    v-if="showCreateEditResponsibleModal"
    :bidderPartnerId="bidderPartnerId"
    :responsibleId="responsibleIdSelected"
    @closeModal="closeModal"
  />
  <AlterStatusResponsibleModal
    v-if="showAlterStatusResponsibleModal"
    :bidderPartnerId="bidderPartnerId"
    :responsibleId="responsibleIdSelected"
    @closeModal="closeModal"
  />
  <DeleteResponsibleModal
    v-if="showDeleteResponsibleModal"
    :bidderPartnerId="bidderPartnerId"
    :responsibleId="responsibleIdSelected"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Responsáveis</h6>
      <div class="ms-auto">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          title="Novo Responsável"
          @click="createEditResponsible()"
        >
          Novo Responsável
        </button>
      </div>
    </div>
    <div v-if="responsibles.length > 0" class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Função</th>
            <th>Cargo</th>
            <th class="text-center">Status</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="responsible in responsibles" :key="responsible.id">
            <td>{{ responsible.name }}</td>
            <td>{{ responsible.function }}</td>
            <td>{{ responsible.role }}</td>
            <td
              class="text-center"
              v-html="statusTranslate(responsible.status)"
            />
            <td class="text-center">
              <button
                type="button"
                class="btn btn-outline-danger btn-icon rounded-pill"
                title="Excluir"
                @click="deleteResponsible(responsible.id)"
              >
                <i class="ph-trash" />
              </button>
              <button
                type="button"
                class="btn btn-outline-teal btn-icon rounded-pill ms-2"
                title="Alterar Status"
                @click="alterStatusResponsible(responsible.id)"
              >
                <i class="ph-lock-open" />
              </button>
              <button
                type="button"
                class="btn btn-outline-warning btn-icon rounded-pill ms-2"
                title="Editar"
                @click="createEditResponsible(responsible.id)"
              >
                <i class="ph-pencil" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="card-body text-center">
      <p class="mb-0">Nenhum responsável cadastrado</p>
    </div>
  </div>
</template>

<script>
import CreateEditResponsibleModal from '@/components/biddersPartners/CreateEditResponsibleModal.vue'
import AlterStatusResponsibleModal from '@/components/biddersPartners/AlterStatusResponsibleModal.vue'
import DeleteResponsibleModal from '@/components/biddersPartners/DeleteResponsibleModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'ListResponsibles',

  components: {
    CreateEditResponsibleModal,
    AlterStatusResponsibleModal,
    DeleteResponsibleModal,
    LoadingData,
  },

  props: {
    bidderPartnerId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditResponsibleModal: false,
      showAlterStatusResponsibleModal: false,
      showDeleteResponsibleModal: false,
      responsibles: [],
      responsibleIdSelected: null,
      statusTranslate,
    }
  },

  methods: {
    async getResponsibles() {
      try {
        this.responsibles = await this.$store.dispatch('getResponsibles', {
          bidderPartnerId: this.bidderPartnerId,
        })

        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditResponsible(responsibleId) {
      this.responsibleIdSelected = responsibleId || null
      this.showCreateEditResponsibleModal = true
    },

    alterStatusResponsible(responsibleId) {
      this.responsibleIdSelected = responsibleId
      this.showAlterStatusResponsibleModal = true
    },

    deleteResponsible(responsibleId) {
      this.responsibleIdSelected = responsibleId
      this.showDeleteResponsibleModal = true
    },

    closeModal(loadListResponsibles) {
      if (loadListResponsibles) {
        this.getResponsibles()
      }
      this.showCreateEditResponsibleModal = false
      this.showAlterStatusResponsibleModal = false
      this.showDeleteResponsibleModal = false
    },
  },

  mounted() {
    this.getResponsibles()
  },
}
</script>
